import React from 'react'
import Products from '../Products'

function Shop() {
  return (
    <>
    <Products/>
    </>
  )
}

export default Shop